export const brandIntro = {
  title: '关于樱花视频',
  subtitle: '樱花视频 - 您的免费高清影视伴侣',
  description: '樱花视频成立于2024年，是一家致力于为用户提供高品质免费影视内容的在线视频平台。我们联合西瓜视频、芒果视频、蓝莓视频等国内主流视频平台，聚合海量高清电影、电视剧、综艺节目和动漫资源，让用户无需付费即可享受流畅高清的观影体验。',
  mission: '我们的使命是让每一个人都能轻松享受优质影视内容，打破付费壁垒，打造真正属于用户的免费高清影视乐园。',
  vision: '成为中文互联网最受欢迎的一站式免费影视聚合平台，以技术创新驱动观影体验的持续升级。',
};

export const milestones = [
  { year: '2024年3月', title: '樱花视频正式上线', description: '平台正式对外发布，首批上线5000+影视资源，涵盖电影、电视剧、综艺、动漫四大品类。' },
  { year: '2024年6月', title: '与西瓜视频达成战略合作', description: '接入西瓜视频海量高清内容库，影视资源数量突破20000+，用户覆盖全国各省市。' },
  { year: '2024年9月', title: '芒果视频内容接入', description: '与芒果TV达成内容合作，引入大量独家综艺节目和热门电视剧集，丰富平台内容生态。' },
  { year: '2025年1月', title: '月活用户突破500万', description: '凭借优质内容和流畅体验，月活跃用户数突破500万大关，成为免费影视领域的重要力量。' },
  { year: '2025年6月', title: '蓝莓视频深度合作', description: '与蓝莓视频建立深度合作关系，进一步拓展动漫和经典电影资源库，平台总内容突破50000+。' },
  { year: '2025年12月', title: '4K超清画质全面上线', description: '技术团队攻克视频编码优化难题，平台全面支持4K超清画质播放，观影体验大幅提升。' },
  { year: '2026年3月', title: '月活用户突破1500万', description: '用户规模再创新高，樱花视频成为中文互联网最具影响力的免费影视平台之一。' },
  { year: '2026年7月', title: 'AI智能推荐系统上线', description: '引入人工智能技术，上线个性化内容推荐系统，为用户精准匹配喜爱的影视内容。' },
];

export const testimonials = [
  {
    id: 1,
    name: '王先生',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20portrait%20photography%20of%20a%20middle-aged%20Chinese%20man%20in%20casual%20attire%20with%20warm%20smile%20friendly%20expression%20clean%20white%20background%20studio%20lighting%20natural%20pose&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '自从发现了樱花视频，再也不用到处找资源了。画质清晰、播放流畅，而且完全免费，真的是良心平台！强烈推荐给身边的朋友。',
    rating: 5,
  },
  {
    id: 2,
    name: '李女士',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%20wearing%20casual%20elegant%20clothes%20natural%20beauty%20clean%20studio%20background%20soft%20diffused%20lighting%20pleasant%20expression&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '我最喜欢樱花视频的综艺专区，芒果视频的独家综艺都能在这里看到。更新速度很快，基本和电视台同步，追综艺太方便了！',
    rating: 5,
  },
  {
    id: 3,
    name: '张同学',
    location: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20young%20Chinese%20male%20university%20student%20with%20glasses%20friendly%20intellectual%20appearance%20clean%20white%20background%20studio%20lighting%20modern%20casual%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '作为一名动漫爱好者，樱花视频的动漫资源真的让我惊喜。不仅有热门日漫，还有很多优质国漫，清晰度也高，看番体验一级棒！',
    rating: 5,
  },
  {
    id: 4,
    name: '陈女士',
    location: '成都',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20young%20Chinese%20woman%20with%20warm%20and%20friendly%20expression%20wearing%20casual%20chic%20outfit%20clean%20studio%20background%20soft%20natural%20lighting%20genuine%20smile&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '晚上下班后就喜欢打开樱花视频追剧，画面清楚而且不卡顿。最新的电视剧都能第一时间看到，太给力了！',
    rating: 4,
  },
];

export const contactInfo = {
  email: 'contact@yinghuavideo.com',
  wechat: 'yinghuavideo_official',
  weibo: '@樱花视频官方',
  address: '北京市朝阳区望京科技园樱花大厦',
  workingHours: '周一至周日 9:00 - 22:00',
  phone: '400-888-6688',
};

export const statsData = [
  { label: '影视资源', value: '50,000+', icon: 'ri-film-line' },
  { label: '日活跃用户', value: '200万+', icon: 'ri-user-heart-line' },
  { label: '月播放量', value: '15亿+', icon: 'ri-play-circle-line' },
  { label: '合作平台', value: '10+', icon: 'ri-shake-hands-line' },
];